import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    scoreList: [],
    consumList: [],
    storageList: [],
    flightList: [],
  },
  mutations: {
    saveScoreList(state,scoreList){
        state.scoreList = scoreList;
    },
    saveConsumList(state,consumList){
      state.consumList = consumList;
    },
    saveStorageList(state,storageList){
      state.storageList = storageList;
    },
    saveFlightList(state,flightList){
      state.flightList = flightList;
    },
  },
  actions: {
  },
  modules: {
  }
})
